// extracted by mini-css-extract-plugin
export var open = "Collapsible-module--open--cf7f3";
export var wrapper = "Collapsible-module--wrapper--75b24";